import { Cell, Column, Row, Table, TableBody, TableHeader } from '@launchpad-ui/components';

import { formatDifferenceValue } from '#components/automated-rollouts/guarded-rollouts/shared';

import type { Metric } from '../types';

import styles from '../tableContainer.module.css';

interface RolloutMetricsTableProps {
  metrics: Metric[];
  showAnalysisUnit?: boolean;
  rolloutContextKind?: string;
}

export function RolloutMetricsTable({ metrics, showAnalysisUnit, rolloutContextKind }: RolloutMetricsTableProps) {
  const showThreshold = metrics.some((m) => m.regressionThreshold !== undefined && m.regressionThreshold !== 0);

  return (
    <div className={styles.tableContainer} data-test-id="metrics-table">
      <Table aria-label="Rollout metrics">
        <TableHeader>
          <Column isRowHeader>Metric</Column>
          {showThreshold && <Column>Threshold</Column>}
          <Column>Auto rollback</Column>
          {showAnalysisUnit && <Column>Analyze by</Column>}
        </TableHeader>
        <TableBody items={metrics}>
          {(metric) => (
            <Row id={metric.metricKey}>
              <Cell>{metric.metricKey}</Cell>
              {showThreshold && (
                <Cell>
                  {metric.regressionThreshold !== undefined
                    ? formatDifferenceValue(
                        metric.regressionThreshold,
                        metric.differenceEstimateType ?? 'relative',
                        metric.unit,
                      )
                    : '0%'}
                </Cell>
              )}
              <Cell>
                <strong>{metric.onRegression?.rollback ? 'on' : 'off'}</strong>
              </Cell>
              {showAnalysisUnit && <Cell>{metric.analysisUnit ?? rolloutContextKind}</Cell>}
            </Row>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
